import Vue from 'vue'

export default {
  SET_LOADING(state, loading) {
    Vue.set(state, 'loading', loading)
  },
  SET_FORMAS_LEITURA(state, formasLeitura) {
    Vue.set(state, 'formasLeitura', formasLeitura)
  },
  ADD_LEITURAS(state, leituras) {
    Vue.set(state, 'leituras', [...leituras])
  },
  SET_LEITURAS(state, leituras) {
    Vue.set(state, 'leituras', leituras)
  },
  SET_LEITURA_EM_EDICAO(state, unidadeFormaLeitura) {
    Vue.set(state, 'leituraEmEdicao', unidadeFormaLeitura)
  },
  SET_FORMA_LEITURA_EM_EDICAO(state, formaLeituraEmEdicao) {
    Vue.set(state, 'formaLeituraEmEdicao', formaLeituraEmEdicao)
  },
  SET_REFERENCIA_EM_EDICAO(state, referenciaEmEdicao) {
    Vue.set(state, 'referenciaEmEdicao', referenciaEmEdicao)
  },
  CLEAR_ALL(state) {
    Vue.set(state, 'formasLeitura', [])
    Vue.set(state, 'leituras', [])
    Vue.set(state, 'leituraEmEdicao', {})
  },
}
